module.exports = __webpack_public_path__ + "static/bytebank-2492035535ed630bb7cff06cef0fc6fb.jpg";